module.exports = __webpack_public_path__ + "static/media/wrangler-swb-1.78896c1a.webp";